import { render } from "./Edit75Liquidation2.vue?vue&type=template&id=be7c2d20"
import script from "./Edit75Liquidation2.vue?vue&type=script&lang=js"
export * from "./Edit75Liquidation2.vue?vue&type=script&lang=js"

import "./Edit75Liquidation2.vue?vue&type=style&index=0&id=be7c2d20&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__